import api from '@/api'

const state = {
  menus: [],
  currentMenuID: ''
}

const mutations = {
  SET_MENUS: (state, menus) => {
    state.menus = menus
  },
  GET_MENUS: (state, name) => {
    state.name = name
  },
  SET_CURRENT_MENU: (state, menuId = '') => {
    state.currentMenuID = menuId;
  },
}

const actions = {
  async getMenus({ commit, state }) {
    if (state.menus && state.menus.length) {
      return Promise.resolve(state.menus);
    }

    const buildAppNode = (appData = []) => {
      if (!appData.length) {
        return null;
      }

      appData = appData.map(v => ({
          name: v.subAppName,
          path: v.url || '',
          id: 'myApp' + v.subAppId,
          children: []
        }));
      return {
        id: 'myApp',
        name: '我的应用',
        path: '',
        icon: 'el-icon-menu',
        children: [{
          id: 'myAppSub',
          name: '我的应用',
          path: '',
          icon: '',
          children: appData
        }]
      };
    };

    const appRes = await api.common.getMyApps()
      .catch(console.log);
    const appNode = buildAppNode(appRes && appRes.data || []);

    // ------------示例数据，业务项目中删除---------------
    let  menus = [
      {
        "id": 1000,
        "icon": "icon-qy-zcflpz",
        "code": "pc-",
        "name": "示例模块",
        "path": "#",
        "children": [{
          "id": 1100,
          "icon": null,
          "code": "X",
          "name": "示例模块",
          "path": "#",
          "children": [{
            "id": 1101,
            "icon": "#icon-qy-xpjd",
            "code": "DashBoard",
            "name": "增删改查类页面",
            "path": "/demo/crud",
            "children": null
          },{
            "id": 1102,
            "icon": "#icon-qy-pzjd",
            "code": "AllocateNode",
            "name": "查询类页面",
            "path": "/demo/report",
            "children": null
          },{
            "id": 1103,
            "icon": "#icon-qy-pzjd",
            "code": "AllocateNode",
            "name": "vxe表格示例-虚拟列表",
            "path": "/demo/virtual-table",
            "children": null
          },{
            "id": 1104,
            "icon": "#icon-qy-pzjd",
            "code": "AllocateNode",
            "name": "流程图",
            "path": "/demo/logic-flow",
            "children": null
          },{
            "id": 1105,
            "icon": "#icon-qy-pzjd",
            "code": "MergeCell",
            "name": "合并单元格",
            "path": "/demo/merge-cell",
            "children": null
          },{
            "id": 1106,
            "icon": "#icon-qy-pzjd",
            "code": "MergeCellNested",
            "name": "嵌套合并单元格",
            "path": "/demo/merge-cell-nested",
            "children": null
          }]
        },{
          "id": 1200,
          "icon": null,
          "code": "X",
          "name": "表头筛选",
          "path": "#",
          "children": [{
            "id": 1201,
            "icon": "#icon-qy-xpjd",
            "code": "DashBoard",
            "name": "前端筛选",
            "path": "/demo/front-filter",
            "children": null
          },{
            "id": 1202,
            "icon": "#icon-qy-pzjd",
            "code": "AllocateNode",
            "name": "接口筛选",
            "path": "/demo/simple-filter",
            "children": null
          },{
            "id": 1203,
            "icon": "#icon-qy-pzjd",
            "code": "AllocateNode",
            "name": "仿Excel-下拉虚拟列表",
            "path": "/demo/excel-filter",
            "children": null
          }]
        }]
      },
      {
        "id": 2000,
        "icon": "icon-qy-zcflpz",
        "code": "pc-",
        "name": "导入导出",
        "path": "#",
        "children": [{
          "id": 2100,
          "icon": null,
          "code": "X",
          "name": "导入",
          "path": "#",
          "children": [{
            "id": 2101,
            "icon": "#icon-qy-xpjd",
            "code": "DashBoard",
            "name": "导入列表",
            "path": "/file/import?appCode=material-manager",
            "children": null
          }]
        }, {
          "id": 2200,
          "icon": null,
          "code": "X",
          "name": "导出",
          "path": "#",
          "children": [{
            "id": 2201,
            "icon": "#icon-qy-xpjd",
            "code": "DashBoard",
            "name": "导出列表",
            "path": "/file/export?appCode=material-manager",
            "children": null
          }]
        }]
      }
    ];
    appNode && menus.unshift(appNode)
    // 当前应用
    menus = [
      {
        id: 'curApp',
        name: '模板演示系统',
        path: '',
        icon: 'el-icon-monitor',
        children: null
      },
      ...menus
    ];
    commit('SET_MENUS', menus);
    return;
    // -------------示例数据 end-----------------------

    return api.common.getMenus().then(({data, success, message}) => {
      if (Array.isArray(data)) {
        let menus = data[0] && data[0].children || [];
        if (appNode) {
          menus = [appNode, ...menus];
        }
        if (data[0]) {
          // 当前appNode
          menus = [
            {
              id: 'curApp',
              name: data[0].nodeName,
              path: '',
              icon: 'el-icon-monitor',
              children: null
            },
            ...menus
          ];
        }
        commit('SET_MENUS', menus)
      }
    }).catch(error => {
      console.log('获取menu错误：', error);
    });
  },
  // 路由切换时，更改左侧导航的选中模块
  moveMenu({ commit, state }, moduleName) {
    const menu = state.menus.find(item => item.nodeName === moduleName);
    if (menu) {
      commit('SET_CURRENT_MENU', menu.id);
    }
  },
  updateCurrentMenu({commit}, menuId) {
    sessionStorage.setItem('currentMenuID', menuId);
    commit('SET_CURRENT_MENU', menuId);
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}